import type { QueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { invalidateSolarPriceDependents } from "./solar-price-dependents"
import type { SolarProposalIncentivesDto } from "../dto/solar-proposal-pricing-steps.dto"

/**
 * Adopts an incentives answer (save or refresh) and refetches what it can
 * move: a Powur-payee incentive changes the stored price's freshness, and a
 * homeowner one the savings.
 */
export const adoptSolarIncentives = (
  queryClient: QueryClient,
  proposalId: string,
  incentives: SolarProposalIncentivesDto,
): void => {
  queryClient.setQueryData(
    queryKeys.solarProposal.incentives(proposalId),
    incentives,
  )
  invalidateSolarPriceDependents(queryClient, proposalId, {
    except: [`header`],
  })
}
